import music from './music'

export default {
    music
}